/* ==========================================
   ABRIR POPUP
========================================== */

document.addEventListener(
    'click',
    e => {

        const trigger =
            e.target.closest(
                '.dias-origem-banner'
            );

        if (!trigger)
            return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const popup =
            document.querySelector(
                '#popup-dias-origem'
            );

        if (!popup)
            return;

        popup.classList.add(
            'is-open'
        );

        document.body.style
            .overflow =
            'hidden';

    },
    true
);

/* ==========================================
   FECHAR NO X E BOTÃO
========================================== */

document.addEventListener(
    'click',
    e => {

        const close =
            e.target.closest(
                '[data-close-dias-origem], .popup-close'
            );

        if (!close)
            return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const popup =
            document.querySelector(
                '#popup-dias-origem'
            );

        if (!popup)
            return;

        popup.classList.remove(
            'is-open'
        );

        document.body.style
            .overflow =
            '';

    },
    true
);

/* ==========================================
   FECHAR CLICANDO FORA
========================================== */

document.addEventListener(
    'click',
    e => {

        const popup =
            document.querySelector(
                '#popup-dias-origem'
            );

        if (
            !popup ||
            !popup.classList.contains(
                'is-open'
            )
        )
            return;

        if (
            e.target === popup
        ) {

            popup.classList.remove(
                'is-open'
            );

            document.body.style
                .overflow =
                '';

        }

    }
);

/* ==========================================
   FECHAR COM ESC
========================================== */

document.addEventListener(
    'keydown',
    e => {

        if (
            e.key !== 'Escape'
        )
            return;

        const popup =
            document.querySelector(
                '#popup-dias-origem'
            );

        if (!popup)
            return;

        popup.classList.remove(
            'is-open'
        );

        document.body.style
            .overflow =
            '';

    }
);